module.exports = __webpack_public_path__ + "img/cg.f1e40852.jpg";